goog.provide('el8.appchart.visitNote.viewTemplatesDialog');

goog.require('el8.appchart.mgr.notes');
goog.require('el8.data.base');
goog.require('el8.data.checklistTemplates');
goog.require('el8.template.appchart.visitNote');
goog.require('el8.uiwidget.NewDialog');


el8.appchart.visitNote.viewTemplatesDialog = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'All Templates',
        autoHeight: false,
        width: 600,
        height: 500,
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.select-trigger',  function() {
            var itemId = $(this).closest('.template-item').data('id');
            el8.appchart.mgr.notes.useChecklistTemplate(itemId);
            that.hide();
            return false;
        });
    };

    var super_show = that.show;
    that.show = function(type) {
        super_show.call(that);
        that.getContentElt().addClass('dataLoading');

        el8.data.checklistTemplates.loadByType(type, function(data) {
            renderList(type);
        });
        that._listenerFn = function() { renderList(type); };
        el8.data.checklistTemplates.bind('all', that._listenerFn);

        that.setTitle('All ' + type.toUpperCase() + ' Templates');

    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        el8.data.checklistTemplates.unbind('all', that._listenerFn);
    };

    function renderList(type) {
        if (!that.isOpen()) { return; }

        var templates = el8.data.checklistTemplates.allType(type);
        that.getContentElt().html(el8.template.appchart.visitNote.templateList({
            // Filter out any empty templates
            type: type,
            templates: templates.filter(function(t) { return !t.isEmpty(); })
                .map(function(t) { return t.asSoyMap(); })
        })).removeClass('dataLoading');
    }

    return that;
})();
